import { Country } from "./country";

export class Province {
    provinceId: number;
    provinceTitle: string;
    provincePersianTitle: string;
    country: Country;
    activeStatus: boolean;
    description: string;

    constructor() {
        this.country = new Country();
    }
}
